import { ActionTypes, ReduxAction } from './types';
import { Benutzer, BenutzerService } from '../../api';
import { Dispatch } from 'redux';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';
import httpSearchQueue from '../../config/HttpSearchQueue';

export const searchBenutzer =
  (searchParam: string, page?: number, searchLimit?: number) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    httpSearchQueue
      .add(new BenutzerService().searchBenutzer, [
        searchParam,
        page,
        searchLimit,
      ])
      .then(response => {
        dispatch({
          type: ActionTypes.SET_TOTALSEARCHRESULTS,
          payload: response.headers['total-search-results'],
        });
        dispatch({
          type: ActionTypes.GET_BENUTZERLISTE,
          payload: response.data,
        });
      });
  };

export const getCurrentBenutzer =
  () =>
  async (
    dispatch: (arg: { type: ActionTypes; payload: Benutzer[] }) => void
  ) => {
    new BenutzerService().getCurrentBenutzer().then(response => {
      dispatch({
        type: ActionTypes.GET_BENUTZERLISTE,
        payload: response.data,
      });
    });
  };

export const setIsauthorized =
  (name: string) =>
  async (dispatch: (arg: { type: ActionTypes; payload: boolean }) => void) => {
    new BenutzerService()
      .checkIfBenutzerNameAllreadyExists(name)
      .then(response => {
        dispatch({
          type: ActionTypes.USERNAME_EXISTS,
          payload: response.data,
        });
      });
  };

export const checkUserExists =
  (name: string) =>
  async (dispatch: (arg: { type: ActionTypes; payload: boolean }) => void) => {
    new BenutzerService()
      .checkIfBenutzerNameAllreadyExists(name)
      .then(response => {
        dispatch({
          type: ActionTypes.USERNAME_EXISTS,
          payload: response.data,
        });
      });
  };

export const forget =
  (nameOrEmail: string) =>
  async (dispatch: (arg: { type: ActionTypes; payload: boolean }) => void) => {
    new BenutzerService().forget(nameOrEmail);
    setNotification(
      'Schauen Sie bitte in Ihre Emails und bestätigen Sie das Passwort.',
      [],
      INFO,
      5000
    );
  };
